/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { DeleteAssetMutation, DeleteAssetMutationVariables } from "@models/graphql";

const defaultDeleteAssetOptions: MutationHookOptions<DeleteAssetMutation, DeleteAssetMutationVariables> = {};

export const useDeleteAsset = (options?: MutationHookOptions<DeleteAssetMutation, DeleteAssetMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<DeleteAssetMutation, DeleteAssetMutationVariables>(
        GraphQLDocuments.deleteAsset
    );

    const deleteAsset = async (
        variables: DeleteAssetMutationVariables,
        opts?: MutationHookOptions<DeleteAssetMutation, DeleteAssetMutationVariables>
    ) => {
        try {
            const response = await mutation({
                ...defaultDeleteAssetOptions,
                ...options,
                ...opts,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        deleteAsset
    };
};
